// /* eslint-disable react-hooks/exhaustive-deps */
// "use client";
// import NewSelectInput from "../../../components/NewSelectInput";
// import ListView from "../../../components/common/ListView";
// import { useCallback, useEffect, useRef, useState } from "react";
// import {
//   useFetchPickCollectFetch,
//   usePickupAllIdData,
// } from "../../../apis/pickupApis";
// import formatDate from "../../../utilities/helper";

// type Props = {
//   selectedRows: string[];
//   setSelectedRows: React.Dispatch<React.SetStateAction<string[]>>;
//   pickupId: string;
//   register: any;
//   setValue: any;
//   watch: any;
//   errors: any;
//   reset: any;
// };

// const PickupCollectModal = ({
//   pickupId,
//   mode,
//   selectedRows,
//   setSelectedRows,
//   register,
//   errors,
//   setValue,
//   watch,
//   reset,
// }: Props & { mode: "manual" | "from-row" }) => {
//   const [awbText, setAwbText] = useState("");
//   const selectAllRef = useRef<HTMLInputElement>(null);
//   const [localPickupId, setLocalPickupId] = useState(pickupId);

//   // Infinite scroll states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [allLeftListData, setAllLeftListData] = useState<any[]>([]);
//   const [allRightListData, setAllRightListData] = useState<any[]>([]);
//   const [hasMore, setHasMore] = useState(true);
//   const [isLoadingMore, setIsLoadingMore] = useState(false);
//   const [isFetchingAll, setIsFetchingAll] = useState(false);

//   const leftScrollRef = useRef<HTMLDivElement>(null);
//   const rightScrollRef = useRef<HTMLDivElement>(null);
//   const loadingPagesRef = useRef(false);

//   // Reset state when mode or pickupId changes
//   useEffect(() => {
//     if (mode === "manual") {
//       setLocalPickupId("");
//       setAwbText("");
//       setSelectedRows([]);
//       setValue("pickupId", "");
//       setValue("shipmentsCount", "");
//       setValue("collectedShipmentsCount", "");
//       setValue("driverContact", "");
//       setValue("sortAddress", "");
//       setValue("fullAddress", "");
//       setValue("createdAt", "");
//       setValue("status", "");
//     } else {
//       setLocalPickupId(pickupId);
//       setValue("pickupId", pickupId);
//     }

//     // Reset infinite scroll state
//     setCurrentPage(1);
//     setAllLeftListData([]);
//     setAllRightListData([]);
//     setHasMore(true);
//     setIsLoadingMore(false);
//     setIsFetchingAll(false);
//     loadingPagesRef.current = false;
//   }, [mode, pickupId, setValue, setSelectedRows]);

//   // Cleanup on unmount
//   useEffect(() => {
//     return () => {
//       setAwbText("");
//       setSelectedRows([]);
//       setLocalPickupId("");
//       setCurrentPage(1);
//       setAllLeftListData([]);
//       setAllRightListData([]);
//       setHasMore(true);
//       setIsLoadingMore(false);
//       setIsFetchingAll(false);
//       loadingPagesRef.current = false;
//       reset();
//     };
//   }, [reset, setSelectedRows]);

//   const { data, isLoading, refetch } = useFetchPickCollectFetch(
//     currentPage,
//     20,
//     "",
//     mode === "manual" && !localPickupId ? "" : localPickupId
//   );

//   useEffect(() => {
//     if (pickupId) {
//       refetch();
//     }
//   }, [pickupId]);

//   const pickupDetails = data?.pickupDetails?.[0] ?? null;

//   useEffect(() => {
//     if (data && !isLoading) {
//       const newLeftList = data?.pickupRequestShipments ?? [];
//       const newRightList = data?.collectedShipments ?? [];

//       if (currentPage === 1) {
//         // First page - reset data
//         setAllLeftListData(newLeftList);
//         setAllRightListData(newRightList);
//       } else {
//         // Subsequent pages - append data
//         setAllLeftListData((prev) => {
//           const newIds = new Set(newLeftList.map((item: any) => item.id));
//           const filtered = prev.filter((item: any) => !newIds.has(item.id));
//           return [...filtered, ...newLeftList];
//         });
//         setAllRightListData((prev) => {
//           const newIds = new Set(newRightList.map((item: any) => item.id));
//           const filtered = prev.filter((item: any) => !newIds.has(item.id));
//           return [...filtered, ...newRightList];
//         });
//       }

//       // Check if there's more data
//       setHasMore(newLeftList.length >= 20 || newRightList.length >= 20);
//       setIsLoadingMore(false);

//       // If we're loading all pages for select all
//       if (loadingPagesRef.current) {
//         const totalPages = data?.totalPages || 1;
//         const totalShipments = data?.total || 0;

//         // Check if we need to load more pages
//         if (currentPage < totalPages) {
//           // Load next page
//           setTimeout(() => {
//             setCurrentPage(prev => prev + 1);
//           }, 100);
//         } else {
//           // All pages loaded, select all
//           loadingPagesRef.current = false;
//           setIsFetchingAll(false);

//           setTimeout(() => {
//             setAllLeftListData((currentData) => {
//               const allIds = currentData.map((d: any) => d.id);
//               setSelectedRows(allIds);
//               return currentData;
//             });
//           }, 200);
//         }
//       }
//     }
//   }, [data, isLoading, currentPage]);

//   useEffect(() => {
//     if (!awbText) return;
//     const pastedAwbs = awbText
//       .split(/[\s,;\n]+/)
//       .map((a) => a.trim())
//       .filter(Boolean);

//     const matchingIds = allLeftListData
//       .filter((d: any) => pastedAwbs.includes(d.awbNumber))
//       .map((d: any) => d.id);

//     const merged = Array.from(new Set([...selectedRows, ...matchingIds]));
//     setSelectedRows(merged);
//   }, [awbText]);

//   // Update checkbox indeterminate state
//   useEffect(() => {
//     if (!selectAllRef.current) return;

//     const totalShipments = data?.total || 0;
//     const selectedCount = selectedRows.length;

//     if (selectedCount === 0) {
//       selectAllRef.current.indeterminate = false;
//       selectAllRef.current.checked = false;
//     } else if (selectedCount === totalShipments) {
//       selectAllRef.current.indeterminate = false;
//       selectAllRef.current.checked = true;
//     } else {
//       selectAllRef.current.indeterminate = true;
//     }
//   }, [selectedRows, data?.total]);

//   const handleSelectAll = () => {
//     const totalShipments = data?.total || 0;
//     const currentLoadedCount = allLeftListData.length;

//     // If all items are already selected, unselect all
//     if (selectedRows.length === totalShipments) {
//       setSelectedRows([]);
//       setIsFetchingAll(false);
//       loadingPagesRef.current = false;
//       return;
//     }

//     // If all data is already loaded, just select them
//     if (currentLoadedCount >= totalShipments) {
//       const allLeftIds = allLeftListData.map((d: any) => d.id);
//       setSelectedRows(allLeftIds);
//     } else {
//       // Start loading all pages
//       setIsFetchingAll(true);
//       loadingPagesRef.current = true;

//       // Trigger loading next page if we're on page 1
//       const totalPages = data?.totalPages || 1;
//       if (currentPage < totalPages) {
//         setCurrentPage(currentPage + 1);
//       }
//     }
//   };

//   // Infinite scroll handler
//   const handleScroll = useCallback(
//     (e: React.UIEvent<HTMLDivElement>) => {
//       if (loadingPagesRef.current) return; // Don't trigger scroll loading during select all

//       const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
//       const isNearBottom = scrollTop + clientHeight >= scrollHeight - 10;

//       if (
//         isNearBottom &&
//         hasMore &&
//         !isLoadingMore &&
//         !isLoading &&
//         localPickupId
//       ) {
//         setIsLoadingMore(true);
//         setCurrentPage((prev) => prev + 1);
//       }
//     },
//     [hasMore, isLoadingMore, isLoading, localPickupId]
//   );

//   const { data: clients } = usePickupAllIdData();

//   useEffect(() => {
//     if (pickupDetails) {
//       setValue("shipmentsCount", pickupDetails.shipmentsCount);
//       setValue(
//         "collectedShipmentsCount",
//         pickupDetails.collectedShipmentsCount
//       );
//       setValue("driverContact", pickupDetails.driverContact);
//       setValue("sortAddress", pickupDetails.sortAddress);
//       setValue("fullAddress", pickupDetails.fullAddress);
//       setValue(
//         "createdAt",
//         pickupDetails.createdAt ? formatDate(pickupDetails.createdAt) : ""
//       );
//       setValue("status", pickupDetails.status);
//     }
//   }, [pickupDetails, setValue]);

//   const formatStatus = (status: string) => {
//     return status
//       ?.toLowerCase()
//       .split("_")
//       .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//       .join(" ");
//   };

//   const handleRowSelect = (awb: string) => {
//     setSelectedRows((prev) =>
//       prev.includes(awb) ? prev.filter((id) => id !== awb) : [...prev, awb]
//     );
//   };

//   const shipments = pickupDetails?.shipments ?? [];
//   const allSelected =
//     selectedRows.length > 0 && selectedRows?.length === shipments.length;

//   return (
//     <div className="w-full space-y-4 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-3xl py-4 px-2 sm:px-4">
//       <div className="space-y-4">
//         <div className="grid grid-cols-1 gap-4">
//           {mode === "manual" && (
//             <div className="grid grid-cols-1 gap-4">
//               <NewSelectInput
//                 label="Enter Manifest ID"
//                 className="w-full"
//                 name="pickupId"
//                 value={watch("pickupId")}
//                 register={register}
//                 onChange={(val) => {
//                   setValue("pickupId", val);
//                   const selectedClient = clients?.find(
//                     (client: any) => client?.id === val
//                   );
//                   setLocalPickupId(selectedClient?.pickupId || "");
//                   setSelectedRows([]);
//                   setAwbText("");
//                   // Reset infinite scroll state
//                   setCurrentPage(1);
//                   setAllLeftListData([]);
//                   setAllRightListData([]);
//                   setHasMore(true);
//                   setIsLoadingMore(false);
//                   setIsFetchingAll(false);
//                   loadingPagesRef.current = false;
//                 }}
//                 selectOptions={
//                   clients?.map((client: any) => ({
//                     id: client?.id,
//                     value: client?.id,
//                     text: client?.pickupId,
//                   })) || []
//                 }
//               />
//             </div>
//           )}
//         </div>

//         <div className="bg-[#FCFDF8] border border-[#D2D2D2] rounded-2xl p-4">
//           <textarea
//             rows={4}
//             className="w-full resize-none outline-none bg-transparent text-sm text-[#212121]/70"
//             placeholder="Paste AWB numbers here..."
//             value={awbText}
//             onChange={(e) => setAwbText(e.target.value)}
//           />
//         </div>

//         <div className="bg-[#FCFDF8] rounded-2xl p-4 space-y-4 border border-slate-200">
//           <div className="flex justify-between items-center">
//             <h2 className="text-[#000000] text-lg font-bold">Shipment Collects</h2>
//           </div>
//           <div className="grid grid-cols-1 gap-6">
//             <div className="space-y-2 relative">
//               <h3 className="text-sm font-semibold text-slate-700">Remaining Shipments</h3>
//               <div
//                 ref={leftScrollRef}
//                 className="w-full p-0 border rounded-2xl max-h-[300px] overflow-x-hidden overflow-y-auto"
//                 onScroll={handleScroll}
//               >
//                 <ListView
//                   mailDivClassName="w-full p-0 h-full text-xs"
//                   mainDivClassName="bg-[#FCFDF8]"
//                   trClassName="hover:bg-[#FBD037]/20 group"
//                   tdClassName="rounded-r-none rounded-l-none"
//                   data={allLeftListData.filter(
//                     (d: any) => !selectedRows.includes(d.id)
//                   )}
//                   columns={[
//                     {
//                       label: (
//                         <label className="relative flex items-center cursor-pointer select-none">
//                           <input
//                             ref={selectAllRef}
//                             type="checkbox"
//                             checked={allSelected}
//                             onChange={handleSelectAll}
//                             disabled={isFetchingAll}
//                             className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-[#D2D2D2] checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all disabled:opacity-50 disabled:cursor-not-allowed"
//                           />
//                           <span className="absolute left-[4px] top-[1px] text-[10px] font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 pointer-events-none">✓</span>
//                           <span className="ml-2">AWB</span>
//                         </label>
//                       ),
//                       render: (c) => {
//                         const isChecked = selectedRows.includes(c.id);
//                         return (
//                           <div className="flex flex-col gap-1 py-1.5">
//                             <div className="flex items-center gap-2">
//                               <label className="relative flex items-center cursor-pointer">
//                                 <input
//                                   type="checkbox"
//                                   checked={isChecked}
//                                   onChange={() => handleRowSelect(c.id)}
//                                   className="peer h-4 w-4 cursor-pointer appearance-none rounded border border-[#D2D2D2] checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
//                                 />
//                                 <span className="absolute text-[10px] font-bold text-white peer-checked:opacity-100 opacity-0 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">✓</span>
//                               </label>
//                               <span className="font-mono font-bold text-slate-800 tracking-wider text-xs">
//                                 {c.awbNumber}
//                               </span>
//                             </div>

//                           </div>
//                         );
//                       },
//                     },
//                     {
//                       label: "Status",
//                       render: (c) => (
//                         <div className="flex justify-center items-center py-1.5">
//                           <span className="rounded-full px-2.5 py-0.5 text-center bg-[#EEEEEE] border border-[#d2d2d2] text-[#212121] text-[10px] font-medium whitespace-nowrap">
//                             {c.status === "READY_FOR_PICKUP"
//                               ? "Ready For Pickup"
//                               : formatStatus(c.status)}
//                           </span>
//                         </div>
//                       ),
//                     },
//                   ]}
//                 />
//                 {(isLoadingMore || isFetchingAll) && !loadingPagesRef.current && (
//                   <div className="flex justify-center items-center py-4 text-xs text-gray-500">
//                     Loading more shipments...
//                   </div>
//                 )}
//               </div>
//             </div>

//             <div className="space-y-2 relative">
//               <h3 className="text-sm font-semibold text-slate-700">Collected Shipments</h3>
//               <div
//                 ref={rightScrollRef}
//                 className="w-full p-0 border rounded-2xl max-h-[300px] overflow-x-hidden overflow-y-auto"
//               >
//                 <ListView
//                   mailDivClassName="w-full p-0 h-full text-xs"
//                   mainDivClassName="bg-[#FCFDF8]"
//                   trClassName="hover:bg-[#FBD037]/20 group"
//                   tdClassName="rounded-r-none rounded-l-none"
//                   data={[
//                     ...allRightListData,
//                     ...allLeftListData.filter((d: any) =>
//                       selectedRows.includes(d.id)
//                     ),
//                   ]}
//                   columns={[
//                     {
//                       label: "AWB / Routing",
//                       render: (c: any) => (
//                         <div className="flex flex-col gap-1 py-1.5 text-left">
//                           <div className="flex items-center gap-2">
//                             <div className="bg-green-500 w-4 h-4 rounded-full flex justify-center items-center text-white text-[10px] shrink-0 font-bold shadow-sm">
//                               ✓
//                             </div>
//                             <span className="font-mono font-bold text-slate-800 tracking-wider text-xs">
//                               {c.awbNumber}
//                             </span>
//                           </div>
//                           <span className="text-[10px] text-slate-500 font-medium pl-6 leading-tight whitespace-normal max-w-[200px]">
//                             {c.senderCity || "—"} ➔ {c.receiverCity || "—"}
//                             {c.receiverCountry ? `, ${c.receiverCountry}` : ""}
//                           </span>
//                         </div>
//                       ),
//                     },
//                     {
//                       label: "Status",
//                       render: (c) => (
//                         <div className="flex justify-center items-center py-1.5">
//                           <span className="rounded-full px-2.5 py-0.5 text-center bg-[#EEEEEE] border border-[#d2d2d2] text-[#212121] text-[10px] font-medium whitespace-nowrap">
//                             {formatStatus(c.status)}
//                           </span>
//                         </div>
//                       ),
//                     },
//                   ]}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PickupCollectModal;








/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import NewSelectInput from "../../../components/NewSelectInput";
import ListView from "../../../components/common/ListView";
import { useCallback, useEffect, useRef, useState } from "react";
import {
  useFetchPickCollectFetch,
  usePickupAllIdData,
} from "../../../apis/pickupApis";
import formatDate from "../../../utilities/helper";
import { IconBox } from "@tabler/icons-react";

type Props = {
  selectedRows: string[];
  setSelectedRows: React.Dispatch<React.SetStateAction<string[]>>;
  pickupId: string;
  register: any;
  setValue: any;
  watch: any;
  errors: any;
  reset: any;
};

const SectionHeader = ({ icon: Icon, title }: { icon: any; title: string }) => (
  <div className="flex items-center gap-2 border-b border-[#FBD037]/30 pb-2 mb-3">
    <div className="p-1.5 rounded-lg bg-[#FBD037]/20">
      <Icon size={16} className="text-[#212121]" stroke={1.5} />
    </div>
    <p className="text-[#212121]/80 uppercase text-[11px] font-bold tracking-wide">
      {title}
    </p>
  </div>
);

const PickupCollectModal = ({
  pickupId,
  mode,
  selectedRows,
  setSelectedRows,
  register,
  errors,
  setValue,
  watch,
  reset,
}: Props & { mode: "manual" | "from-row" }) => {
  const [awbText, setAwbText] = useState("");
  const selectAllRef = useRef<HTMLInputElement>(null);
  const [localPickupId, setLocalPickupId] = useState(pickupId);

  // Infinite scroll states
  const [currentPage, setCurrentPage] = useState(1);
  const [allShipments, setAllShipments] = useState<any[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [isFetchingAll, setIsFetchingAll] = useState(false);

  const listScrollRef = useRef<HTMLDivElement>(null);
  const loadingPagesRef = useRef(false);

  // Reset state when mode or pickupId changes
  useEffect(() => {
    if (mode === "manual") {
      setLocalPickupId("");
      setAwbText("");
      setSelectedRows([]);
      setValue("pickupId", "");
      setValue("shipmentsCount", "");
      setValue("collectedShipmentsCount", "");
      setValue("driverContact", "");
      setValue("sortAddress", "");
      setValue("fullAddress", "");
      setValue("createdAt", "");
      setValue("status", "");
    } else {
      setLocalPickupId(pickupId);
      setValue("pickupId", pickupId);
    }

    setCurrentPage(1);
    setAllShipments([]);
    setHasMore(true);
    setIsLoadingMore(false);
    setIsFetchingAll(false);
    loadingPagesRef.current = false;
  }, [mode, pickupId, setValue, setSelectedRows]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      setAwbText("");
      setLocalPickupId("");
      setCurrentPage(1);
      setAllShipments([]);
      setHasMore(true);
      setIsLoadingMore(false);
      setIsFetchingAll(false);
      loadingPagesRef.current = false;
      reset();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const { data, isLoading, refetch } = useFetchPickCollectFetch(
    currentPage,
    20,
    "",
    mode === "manual" && !localPickupId ? "" : localPickupId,
  );

  useEffect(() => {
    if (pickupId) {
      refetch();
    }
  }, [pickupId]);

  const pickupDetails = data?.pickupDetails?.[0] ?? null;

  // Combine both arrays into one list
  useEffect(() => {
    if (data && !isLoading) {
      const left = data?.pickupRequestShipments ?? [];
      const right = data?.collectedShipments ?? [];

      const combined = [
        ...left.map((item: any) => ({ ...item, isCollected: false })),
        ...right.map((item: any) => ({ ...item, isCollected: true })),
      ];

      if (currentPage === 1) {
        setAllShipments(combined);
      } else {
        setAllShipments((prev) => {
          const existingIds = new Set(prev.map((item) => item.id));
          const newItems = combined.filter((item) => !existingIds.has(item.id));
          return [...prev, ...newItems];
        });
      }

      const totalLoaded = allShipments.length + combined.length;
      setHasMore(totalLoaded < (data?.total || 0));

      setIsLoadingMore(false);

      if (loadingPagesRef.current) {
        const totalPages = data?.totalPages || 1;
        if (currentPage < totalPages) {
          setTimeout(() => {
            setCurrentPage((prev) => prev + 1);
          }, 100);
        } else {
          loadingPagesRef.current = false;
          setIsFetchingAll(false);
          setTimeout(() => {
            const allIds = allShipments.map((d: any) => d.id);
            setSelectedRows(allIds);
          }, 200);
        }
      }
    }
  }, [data, isLoading, currentPage]);

  // Handle paste AWB
  useEffect(() => {
    if (!awbText) return;
    const pastedAwbs = awbText
      .split(/[\s,;\n]+/)
      .map((a) => a.trim())
      .filter(Boolean);

    const matchingIds = allShipments
      .filter((d: any) => pastedAwbs.includes(d.awbNumber))
      .map((d: any) => d.id);

    setSelectedRows((prev) => {
      const merged = new Set([...prev, ...matchingIds]);
      return Array.from(merged);
    });
  }, [awbText, allShipments]);

  // Update checkbox indeterminate state
  useEffect(() => {
    if (!selectAllRef.current) return;
    const totalShipments = data?.total || 0;
    const selectedCount = selectedRows.length;

    if (selectedCount === 0) {
      selectAllRef.current.indeterminate = false;
      selectAllRef.current.checked = false;
    } else if (selectedCount === totalShipments) {
      selectAllRef.current.indeterminate = false;
      selectAllRef.current.checked = true;
    } else {
      selectAllRef.current.indeterminate = true;
    }
  }, [selectedRows, data?.total]);

  const handleSelectAll = () => {
    const totalShipments = data?.total || 0;
    const currentLoadedCount = allShipments.length;

    if (selectedRows.length === totalShipments) {
      setSelectedRows([]);
      setIsFetchingAll(false);
      loadingPagesRef.current = false;
      return;
    }

    if (currentLoadedCount >= totalShipments) {
      const allIds = allShipments.map((d: any) => d.id);
      setSelectedRows(allIds);
    } else {
      setIsFetchingAll(true);
      loadingPagesRef.current = true;
      const totalPages = data?.totalPages || 1;
      if (currentPage < totalPages) {
        setCurrentPage(currentPage + 1);
      }
    }
  };

  // Infinite scroll handler
  const handleScroll = useCallback(
    (e: React.UIEvent<HTMLDivElement>) => {
      if (loadingPagesRef.current) return;
      const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - 10;

      if (
        isNearBottom &&
        hasMore &&
        !isLoadingMore &&
        !isLoading &&
        localPickupId
      ) {
        setIsLoadingMore(true);
        setCurrentPage((prev) => prev + 1);
      }
    },
    [hasMore, isLoadingMore, isLoading, localPickupId],
  );

  const { data: clients } = usePickupAllIdData();

  useEffect(() => {
    if (pickupDetails) {
      setValue("shipmentsCount", pickupDetails.shipmentsCount);
      setValue(
        "collectedShipmentsCount",
        pickupDetails.collectedShipmentsCount,
      );
      setValue("driverContact", pickupDetails.driverContact);
      setValue("sortAddress", pickupDetails.sortAddress);
      setValue("fullAddress", pickupDetails.fullAddress);
      setValue(
        "createdAt",
        pickupDetails.createdAt ? formatDate(pickupDetails.createdAt) : "",
      );
      setValue("status", pickupDetails.status);
    }
  }, [pickupDetails, setValue]);

  const formatStatus = (status: string) => {
    return status
      ?.toLowerCase()
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  // Dynamic checkbox color based on status
  const getCheckboxColorClass = (status: string) => {
    const normalized = status?.toUpperCase();
    if (normalized === "READY_FOR_PICKUP")
      return "checked:bg-green-500 checked:border-green-500";
    if (normalized === "PENDING" || normalized === "CREATED")
      return "checked:bg-yellow-500 checked:border-yellow-500";
    if (normalized === "FAILED" || normalized === "CANCELLED")
      return "checked:bg-red-500 checked:border-red-500";
    return "checked:bg-[#FBD037] checked:border-[#FBD037]";
  };

  // Get status badge color
  const getStatusBadgeClass = (status: string) => {
    const s = status?.toUpperCase();
    if (s === "READY_FOR_PICKUP")
      return "bg-green-100 text-green-800 border-green-300";
    if (s === "COLLECTED") return "bg-blue-100 text-blue-800 border-blue-300";
    if (s === "PENDING" || s === "CREATED")
      return "bg-yellow-100 text-yellow-800 border-yellow-300";
    if (s === "FAILED" || s === "CANCELLED")
      return "bg-red-100 text-red-800 border-red-300";
    return "bg-gray-100 text-gray-800 border-gray-300";
  };

  const allSelected =
    selectedRows.length > 0 && selectedRows.length === (data?.total || 0);

  const handleSelectionToggle = (id: string) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((row) => row !== id) : [...prev, id],
    );
  };

  // Compute summary counts
  const total = data?.total || 0;
  const collected = data?.collectedShipments?.length || 0;
  const selected = selectedRows.length;

  return (
    <div className="group rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3 shadow-sm hover:shadow-md">
      <SectionHeader icon={IconBox} title="Pickup Collect" />
      <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />

      {/* Manual mode: Pickup ID selector */}
      {mode === "manual" && (
        <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-200">
          <NewSelectInput
            label="Enter Manifest ID"
            className="w-full"
            name="pickupId"
            value={watch("pickupId")}
            register={register}
            onChange={(val) => {
              setValue("pickupId", val);
              const selectedClient = clients?.find(
                (client: any) => client?.id === val,
              );
              setLocalPickupId(selectedClient?.pickupId || "");
              setSelectedRows([]);
              setAwbText("");
              setCurrentPage(1);
              setAllShipments([]);
              setHasMore(true);
              setIsLoadingMore(false);
              setIsFetchingAll(false);
              loadingPagesRef.current = false;
            }}
            selectOptions={
              clients?.map((client: any) => ({
                id: client?.id,
                value: client?.id,
                text: client?.pickupId,
              })) || []
            }
          />
        </div>
      )}

      {/* AWB Paste Area */}
      <div className=" ">
        <label className="text-sm font-medium text-gray-700 mb-1 block">
          Scan Or Past AWB
        </label>
        <textarea
          rows={3}
          className="w-full resize-none outline-none bg-gray-50 rounded-lg p-3 text-sm text-gray-700 placeholder-gray-400 border border-gray-200 focus:border-amber-400 transition"
          value={awbText}
          onChange={(e) => setAwbText(e.target.value)}
        />
      </div>

      {/* Shipments List */}
      <div className="bg-white rounded-xl border overflow-hidden">
        <div className="flex items-center justify-between px-5 py-3 border-b">
          <h3 className="text-sm font-semibold text-gray-700 flex items-center gap-2">
            <span>All Shipments</span>
            <span className="bg-gray-200 text-gray-700 text-xs px-2 py-0.5 rounded-full">
              {selected} / {total}
            </span>
          </h3>
        </div>

        <div
          ref={listScrollRef}
          className="max-h-[420px] overflow-x-hidden overflow-y-auto"
          onScroll={handleScroll}
        >
          <ListView
            mailDivClassName="w-full p-0 h-full text-sm"
            mainDivClassName="bg-white"
            trClassName="hover:bg-amber-50/50 transition-colors group border-b border-gray-100 last:border-0"
            tdClassName="px-4 py-2 align-middle"
            data={allShipments}
            columns={[
              {
                label: (
                  <div className="flex items-center gap-2">
                    <input
                      ref={selectAllRef}
                      type="checkbox"
                      checked={allSelected}
                      onChange={handleSelectAll}
                      disabled={isFetchingAll}
                      className="h-4 w-4 rounded border-gray-300 accent-[#FBD037] disabled:opacity-50 transition"
                    />
                    <span className="text-xs font-medium text-gray-600">
                      AWB
                    </span>
                  </div>
                ),
                render: (c) => {
                  const isChecked = selectedRows.includes(c.id);
                  const colorClass = getCheckboxColorClass(c.status);
                  return (
                    <div className="flex items-center gap-2">
                      <label className="relative flex items-center cursor-pointer">
                        <input
                          type="checkbox"
                          checked={isChecked}
                          onChange={() => handleSelectionToggle(c.id)}
                          className={`h-4 w-4 rounded border-gray-300 transition accent-[#FBD037] ${colorClass} focus:ring-2 focus:ring-amber-300`}
                        />
                      </label>
                      <span className="font-semibold text-gray-800 tracking-wide text-sm">
                        {c.awbNumber}
                      </span>
                      {c.isCollected && (
                        <span className=" text-[10px] font-semibold text-green-700 bg-green-100 px-2 py-0.5 rounded-full border border-green-200">
                          Collected
                        </span>
                      )}
                    </div>
                  );
                },
              },
              {
                label: "Status",
                render: (c) => (
                  <div className="flex justify-center items-center py-1.5">
                    <span className="rounded-full px-2.5 py-0.5 text-center bg-[#EEEEEE] border border-[#d2d2d2] text-[#212121] text-[10px] font-medium whitespace-nowrap">
                      {c.status === "READY_FOR_PICKUP"
                        ? "Ready For Pickup"
                        : formatStatus(c.status)}
                    </span>
                  </div>
                ),
              },
            ]}
          />
          {(isLoadingMore || isFetchingAll) && !loadingPagesRef.current && (
            <div className="flex justify-center items-center py-4 text-sm text-gray-500">
              <svg
                className="animate-spin h-5 w-5 mr-2 text-amber-500"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                />
              </svg>
              Loading more shipments...
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PickupCollectModal;

















// /* eslint-disable react-hooks/exhaustive-deps */
// "use client";
// import Section from "../../../components/common/Section";
// import NewSelectInput from "../../../components/NewSelectInput";
// import ListView from "../../../components/common/ListView";
// import { useCallback, useEffect, useRef, useState } from "react";
// import {
//   useFetchPickCollectFetch,
//   usePickupAllIdData,
// } from "../../../apis/pickupApis";

// const InfoRow = ({
//   label,
//   value,
//   className,
// }: {
//   label: string;
//   value: React.ReactNode;
//   className?: string;
// }) => (
//   <div className={`flex items-center gap-2 w-full ${className}`}>
//     <h2 className="capitalize text-[#212121] text-sm font-medium">{label} :</h2>
//     <div>
//       {typeof value === "string" ? (
//         <p className="text-[#1E293B] text-base">{value}</p>
//       ) : (
//         value
//       )}
//     </div>
//   </div>
// );

// type Props = {
//   selectedRows: string[];
//   setSelectedRows: React.Dispatch<React.SetStateAction<string[]>>;
//   pickupId: string;
//   register: any;
//   setValue: any;
//   watch: any;
//   errors: any;
//   reset: any;
// };

// const PickupCollectModal = ({
//   pickupId,
//   mode,
//   selectedRows,
//   setSelectedRows,
//   register,
//   errors,
//   setValue,
//   watch,
//   reset,
// }: Props & { mode: "manual" | "from-row" }) => {
//   const [awbText, setAwbText] = useState("");
//   const selectAllRef = useRef<HTMLInputElement>(null);
//   const [localPickupId, setLocalPickupId] = useState(pickupId);

//   // Infinite scroll states
//   const [currentPage, setCurrentPage] = useState(1);
//   const [allLeftListData, setAllLeftListData] = useState<any[]>([]);
//   const [allRightListData, setAllRightListData] = useState<any[]>([]);
//   const [hasMore, setHasMore] = useState(true);
//   const [isLoadingMore, setIsLoadingMore] = useState(false);
//   const leftScrollRef = useRef<HTMLDivElement>(null);
//   const rightScrollRef = useRef<HTMLDivElement>(null);

//   // Reset state when mode or pickupId changes
//   useEffect(() => {
//     if (mode === "manual") {
//       setLocalPickupId("");
//       setAwbText("");
//       setSelectedRows([]);
//       setValue("pickupId", "");
//       setValue("shipmentsCount", "");
//       setValue("collectedShipmentsCount", "");
//       setValue("driverContact", "");
//       setValue("sortAddress", "");
//       setValue("fullAddress", "");
//       setValue("createdAt", "");
//       setValue("status", "");
//     } else {
//       setLocalPickupId(pickupId);
//       setValue("pickupId", pickupId);
//     }

//     // Reset infinite scroll state
//     setCurrentPage(1);
//     setAllLeftListData([]);
//     setAllRightListData([]);
//     setHasMore(true);
//     setIsLoadingMore(false);
//   }, [mode, pickupId, setValue, setSelectedRows]);

//   // Cleanup on unmount
//   useEffect(() => {
//     return () => {
//       setAwbText("");
//       setSelectedRows([]);
//       setLocalPickupId("");
//       setCurrentPage(1);
//       setAllLeftListData([]);
//       setAllRightListData([]);
//       setHasMore(true);
//       setIsLoadingMore(false);
//       reset();
//     };
//   }, [reset, setSelectedRows]);

//   const { data, isLoading, refetch } = useFetchPickCollectFetch(
//     currentPage,
//     20,
//     "",
//     mode === "manual" && !localPickupId ? "" : localPickupId
//   );

//   useEffect(() => {
//     if (pickupId) {
//       refetch();
//     }
//   }, [pickupId])

//   const pickupDetails = data?.pickupDetails?.[0] ?? null;

//   useEffect(() => {
//     if (data && !isLoading) {
//       const newLeftList = data?.pickupRequestShipments ?? [];
//       const newRightList = data?.collectedShipments ?? [];

//       if (currentPage === 1) {
//         // First page - reset data
//         setAllLeftListData(newLeftList);
//         setAllRightListData(newRightList);
//       } else {
//         // Subsequent pages - append data
//         setAllLeftListData((prev) => {
//           const newIds = new Set(newLeftList.map((item: any) => item.id));
//           const filtered = prev.filter((item: any) => !newIds.has(item.id));
//           return [...filtered, ...newLeftList];
//         });
//         setAllRightListData((prev) => {
//           const newIds = new Set(newRightList.map((item: any) => item.id));
//           const filtered = prev.filter((item: any) => !newIds.has(item.id));
//           return [...filtered, ...newRightList];
//         });
//       }

//       // Check if there's more data
//       setHasMore(newLeftList.length >= 20 || newRightList.length >= 20);
//       setIsLoadingMore(false);
//     }
//   }, [data, isLoading, currentPage]);

//   useEffect(() => {
//     if (!awbText) return;
//     const pastedAwbs = awbText
//       .split(/[\s,;\n]+/)
//       .map((a) => a.trim())
//       .filter(Boolean);

//     const matchingIds = allLeftListData
//       .filter((d: any) => pastedAwbs.includes(d.awbNumber))
//       .map((d: any) => d.id);

//     const merged = Array.from(new Set([...selectedRows, ...matchingIds]));
//     setSelectedRows(merged);
//   }, [awbText, allLeftListData, selectedRows, setSelectedRows]);

//   useEffect(() => {
//     if (!selectAllRef.current) return;
//     const availableLeftData = allLeftListData.filter(
//       (d: any) => !selectedRows.includes(d.id)
//     );
//     if (selectedRows.length === 0) {
//       selectAllRef.current.indeterminate = false;
//       selectAllRef.current.checked = false;
//     } else if (availableLeftData.length === 0 && allLeftListData.length > 0) {
//       selectAllRef.current.indeterminate = false;
//       selectAllRef.current.checked = true;
//     } else {
//       selectAllRef.current.indeterminate = true;
//     }
//   }, [selectedRows, allLeftListData]);

//   const handleSelectAll = () => {
//     const availableLeftData = allLeftListData.filter(
//       (d: any) => !selectedRows.includes(d.id)
//     );
//     if (availableLeftData.length === 0 && allLeftListData.length > 0) {
//       // Unselect all
//       const leftDataIds = new Set(allLeftListData.map((d: any) => d.id));
//       setSelectedRows(selectedRows.filter((id) => !leftDataIds.has(id)));
//     } else {
//       // Select all available
//       const allLeftIds = allLeftListData.map((d: { id: any }) => d.id);
//       const merged = Array.from(new Set([...selectedRows, ...allLeftIds]));
//       setSelectedRows(merged);
//     }
//   };

//   // Infinite scroll handler
//   const handleScroll = useCallback(
//     (e: React.UIEvent<HTMLDivElement>) => {
//       const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
//       const isNearBottom = scrollTop + clientHeight >= scrollHeight - 10;

//       if (
//         isNearBottom &&
//         hasMore &&
//         !isLoadingMore &&
//         !isLoading &&
//         localPickupId
//       ) {
//         setIsLoadingMore(true);
//         setCurrentPage((prev) => prev + 1);
//       }
//     },
//     [hasMore, isLoadingMore, isLoading, localPickupId]
//   );

//   const { data: clients } = usePickupAllIdData();

//   useEffect(() => {
//     if (pickupDetails) {
//       setValue("shipmentsCount", pickupDetails.shipmentsCount);
//       setValue(
//         "collectedShipmentsCount",
//         pickupDetails.collectedShipmentsCount
//       );
//       setValue("driverContact", pickupDetails.driverContact);
//       setValue("sortAddress", pickupDetails.sortAddress);
//       setValue("fullAddress", pickupDetails.fullAddress);
//       setValue(
//         "createdAt",
//         new Date(pickupDetails.createdAt).toLocaleDateString()
//       );
//       setValue("status", pickupDetails.status);
//     }
//   }, [pickupDetails, setValue]);

//   if (isLoading) {
//     return (
//       <div className="w-full space-y-4 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
//         <div className="h-[calc(100vh-10rem)] overflow-y-auto space-y-4 p-6 scrollbar-clean">
//           <p className="p-4">Loading...</p>
//         </div>
//       </div>
//     );
//   }

//   const formatStatus = (status: string) => {
//     return status
//       ?.toLowerCase()
//       .split("_")
//       .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
//       .join(" ");
//   };

//   const handleRowSelect = (awb: string) => {
//     setSelectedRows((prev) =>
//       prev.includes(awb) ? prev.filter((id) => id !== awb) : [...prev, awb]
//     );
//   };

//   const shipments = pickupDetails?.shipments ?? [];
//   const allSelected = selectedRows.length > 0 && selectedRows?.length === shipments.length;

//   return (
//     <div className="w-full space-y-4 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
//       <div className="h-[calc(100vh-10rem)] overflow-y-auto space-y-4 p-6 scrollbar-clean">
//         <div className="grid grid-cols-1 gap-4">
//           {mode === "manual" && (
//             <div className="grid grid-cols-1 gap-4">
//               <NewSelectInput
//                 label="Enter Manifest ID"
//                 className="col-span-2"
//                 name="pickupId"
//                 value={watch("pickupId")}
//                 register={register}
//                 onChange={(val) => {
//                   setValue("pickupId", val);
//                   const selectedClient = clients?.find(
//                     (client: any) => client?.id === val
//                   );
//                   setLocalPickupId(selectedClient?.pickupId || "");
//                   setSelectedRows([]);
//                   setAwbText("");
//                   // Reset infinite scroll state
//                   setCurrentPage(1);
//                   setAllLeftListData([]);
//                   setAllRightListData([]);
//                   setHasMore(true);
//                   setIsLoadingMore(false);
//                 }}
//                 selectOptions={
//                   clients?.map((client: any) => ({
//                     id: client?.id,
//                     value: client?.id,
//                     text: client?.pickupId,
//                   })) || []
//                 }
//               />
//             </div>
//           )}
//         </div>

//         {pickupDetails && (
//           <Section
//             className="lg:col-span-5 md:col-span-3 sm:col-span-2 col-span-1"
//             mainClassName="grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 border-[1.5px] border-[#D2D2D2] p-2 rounded-lg"
//             title="Manifest Info"
//           >
//             <InfoRow label="Pickup ID" value={pickupDetails.pickupId} />
//             <InfoRow label="Shipments" value={pickupDetails.shipmentsCount} />
//             <InfoRow
//               label="Collected"
//               value={pickupDetails.collectedShipmentsCount}
//             />
//             <InfoRow label="Phone" value={pickupDetails.driverContact} />
//             <InfoRow label="Short Add" value={pickupDetails.sortAddress} />
//             <InfoRow
//               className="lg:col-span-3 md:col-span-2 sm:col-span-2 col-span-1"
//               label="Address"
//               value={pickupDetails.fullAddress}
//             />
//             <InfoRow
//               label="Date"
//               value={new Date(pickupDetails.createdAt).toLocaleDateString()}
//             />
//             <InfoRow
//               label="Status"
//               value={
//                 <button className="rounded-full w-fit px-4 py-1 text-xs font-medium text-center bg-[#C6DFF7] border border-[#0088FF] text-[#212121]">
//                   {pickupDetails.status}
//                 </button>
//               }
//             />
//           </Section>
//         )}

//         <div className="bg-[#FCFDF8] border-[1.5px] border-[#D2D2D2] rounded-xl p-4">
//           <textarea
//             className="w-full h-full resize-none outline-none bg-transparent text-xs text-[#212121]/70"
//             placeholder="Paste AWB numbers here..."
//             value={awbText}
//             onChange={(e) => setAwbText(e.target.value)}
//           />
//         </div>

//         <div className="bg-[#FCFDF8] rounded-xl p-4 space-y-4">
//           <div className="flex justify-between items-center">
//             <h2 className="text-[#000000] text-xl">Shipment Collects</h2>
//           </div>
//           <div className="grid grid-cols-2 bg-[#FCFDF8] rounded-3xl gap-6">
//             <div className="relative">
//               <div
//                 ref={leftScrollRef}
//                 className="w-full p-0 border rounded-lg h-[390px] overflow-y-auto"
//                 onScroll={handleScroll}
//               >
//                 <ListView
//                   mailDivClassName="w-full p-0 h-full"
//                   mainDivClassName="bg-[#FCFDF8]"
//                   trClassName="hover:bg-[#FBD037]/20 group"
//                   tdClassName="rounded-r-none rounded-l-none"
//                   data={allLeftListData.filter(
//                     (d: any) => !selectedRows.includes(d.id)
//                   )}
//                   columns={[
//                          {
//                       label: (
//                         <label className="relative flex items-center cursor-pointer">
//                           <input
//                             type="checkbox"
//                             checked={allSelected}
//                             onChange={handleSelectAll}
//                             className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300
//       checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
//                           />
//                           <span
//                             className="absolute left-[5px] top-[2px] text-xs font-bold text-white
//       peer-checked:opacity-100 opacity-0 transition-opacity duration-200
//       pointer-events-none"
//                           >
//                             ✓
//                           </span>
//                           <span className="ml-2">AWB</span>
//                         </label>
//                       ),
//                       render: (c) => {
//                         const isChecked = selectedRows.includes(c.id);
//                         return (
//                           <div className="flex items-center gap-1">
//                             <label className="relative flex items-center cursor-pointer">
//                               <input
//                                 type="checkbox"
//                                 checked={isChecked}
//                                 onChange={() => handleRowSelect(c.id)}
//                                 className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300
//                   checked:border-[#FBD037] bg-white checked:bg-[#FBD037] transition-all"
//                               />
//                               <span
//                                 className="absolute text-xs font-bold text-white peer-checked:opacity-100
//                   opacity-0 transition-opacity duration-200 top-1/2 left-1/2
//                   transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
//                               >
//                                 ✓
//                               </span>
//                             </label>
//                             <span>{c.awbNumber}</span>
//                           </div>
//                         );
//                       },
//                     },
//                     { label: "Origin", render: (c: any) => c.senderCity },
//                     {
//                       label: "Destination",
//                       children: [
//                         {
//                           label: "Country",
//                           render: (c: any) => c.receiverCountry,
//                         },
//                         { label: "City", render: (c: any) => c.receiverCity },
//                         {
//                           label: "District",
//                           render: (c: any) => c.receiverDistrict,
//                         },
//                       ],
//                     },
//                     {
//                       label: "Status",
//                       render: (c) => (
//                         <div className="flex justify-center items-center">
//                           <button className="rounded-full px-4 py-1 text-center bg-[#EEEEEE] border border-[#d2d2d2] text-[#212121] text-xs">
//                             {c.status === "READY_FOR_PICKUP" &&
//                               "Ready For Pickup"}
//                           </button>
//                         </div>
//                       ),
//                     },
//                   ]}
//                 />
//                 {isLoadingMore && (
//                   <div className="flex justify-center items-center py-4 text-sm text-gray-500">
//                     Loading more shipments...
//                   </div>
//                 )}
//               </div>
//             </div>

//             <div className="relative">
//               <div
//                 ref={rightScrollRef}
//                 className="w-full p-0 border rounded-lg h-[390px] overflow-y-auto"
//               >
//                 <ListView
//                   mailDivClassName="w-full p-0 h-full"
//                   mainDivClassName="bg-[#FCFDF8]"
//                   trClassName="hover:bg-[#FBD037]/20 group"
//                   tdClassName="rounded-r-none rounded-l-none"
//                   data={[
//                     ...allRightListData,
//                     ...allLeftListData.filter((d: any) =>
//                       selectedRows.includes(d.id)
//                     ),
//                   ]}
//                   columns={[
//                     {
//                       label: "AWB",
//                       render: (c: any) => (
//                         <div className="flex items-center gap-2">
//                           <div className="bg-green-500 w-6 h-6 rounded-full flex justify-center items-center text-white text-sm">
//                             ✓
//                           </div>
//                           <p>{c.awbNumber}</p>
//                         </div>
//                       ),
//                     },
//                     { label: "Origin", render: (c: any) => c.senderCity },
//                     {
//                       label: "Destination",
//                       children: [
//                         {
//                           label: "Country",
//                           render: (c: any) => c.receiverCountry,
//                         },
//                         { label: "City", render: (c: any) => c.receiverCity },
//                         {
//                           label: "District",
//                           render: (c: any) => c.receiverDistrict,
//                         },
//                       ],
//                     },
//                     {
//                       label: "Status",
//                       render: (c) => (
//                         <div className="flex justify-center items-center">
//                           <button className="rounded-full px-4 py-1 text-center bg-[#EEEEEE] border border-[#d2d2d2] text-[#212121] text-xs">
//                             {formatStatus(c.status)}
//                           </button>
//                         </div>
//                       ),
//                     },
//                   ]}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PickupCollectModal;
